<template>
  <section class="flag-icons">
    <div class="row">
      <div class="col-lg-12 grid-margin">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title">Flag icons</h4>
            <div class="icons-list row">
              <div class="col-3">
                <i class="flag-icon flag-icon-ad" title="ad" id="ad"></i> AD</div>
              <div class="col-3">
                <i class="flag-icon flag-icon-ae" title="ae" id="ae"></i> AE</div>
              <div class="col-3">
                <i class="flag-icon flag-icon-af" title="af" id="af"></i> AF</div>
              <div class="col-3">
                <i class="flag-icon flag-icon-ag" title="ag" id="ag"></i> AG</div>
              <div class="col-3">
                <i class="flag-icon flag-icon-ai" title="ai" id="ai"></i> AU</div>
              <div class="col-3">
                <i class="flag-icon flag-icon-al" title="al" id="al"></i> AL</div>
              <div class="col-3">
                <i class="flag-icon flag-icon-am" title="am" id="am"></i> AM</div>
              <div class="col-3">
                <i class="flag-icon flag-icon-ao" title="ao" id="ao"></i> AO</div>
              <div class="col-3">
                <i class="flag-icon flag-icon-aq" title="aq" id="aq"></i> AQ</div>
              <div class="col-3">
                <i class="flag-icon flag-icon-ar" title="ar" id="ar"></i> AR</div>
              <div class="col-3">
                <i class="flag-icon flag-icon-as" title="as" id="as"></i> AS</div>
              <div class="col-3">
                <i class="flag-icon flag-icon-at" title="at" id="at"></i> AT</div>
              <div class="col-3">
                <i class="flag-icon flag-icon-au" title="au" id="au"></i> AU</div>
              <div class="col-3">
                <i class="flag-icon flag-icon-aw" title="aw" id="aw"></i> AW</div>
              <div class="col-3">
                <i class="flag-icon flag-icon-ax" title="ax" id="ax"></i> AX</div>
              <div class="col-3">
                <i class="flag-icon flag-icon-az" title="az" id="az"></i> AZ</div>
              <div class="col-3">
                <i class="flag-icon flag-icon-ba" title="ba" id="ba"></i> BA</div>
              <div class="col-3">
                <i class="flag-icon flag-icon-bb" title="bb" id="bb"></i> BB</div>
              <div class="col-3">
                <i class="flag-icon flag-icon-bd" title="bd" id="bd"></i> BD</div>
              <div class="col-3">
                <i class="flag-icon flag-icon-be" title="be" id="be"></i> BE</div>
              <div class="col-3">
                <i class="flag-icon flag-icon-bf" title="bf" id="bf"></i> BF</div>
              <div class="col-3">
                <i class="flag-icon flag-icon-bg" title="bg" id="bg"></i> BG</div>
              <div class="col-3">
                <i class="flag-icon flag-icon-bh" title="bh" id="bh"></i> BH</div>
              <div class="col-3">
                <i class="flag-icon flag-icon-bi" title="bi" id="bi"></i> BI</div>
              <div class="col-3">
                <i class="flag-icon flag-icon-bj" title="bj" id="bj"></i> BJ</div>
              <div class="col-3">
                <i class="flag-icon flag-icon-bl" title="bl" id="bl"></i> BL</div>
              <div class="col-3">
                <i class="flag-icon flag-icon-bm" title="bm" id="bm"></i> BM</div>
              <div class="col-3">
                <i class="flag-icon flag-icon-bn" title="bn" id="bn"></i> BN</div>
              <div class="col-3">
                <i class="flag-icon flag-icon-bo" title="bo" id="bo"></i> BO</div>
              <div class="col-3">
                <i class="flag-icon flag-icon-bq" title="bq" id="bq"></i> BQ</div>
              <div class="col-3">
                <i class="flag-icon flag-icon-br" title="br" id="br"></i> BR</div>
              <div class="col-3">
                <i class="flag-icon flag-icon-bs" title="bs" id="bs"></i> BS</div>
              <div class="col-3">
                <i class="flag-icon flag-icon-bt" title="bt" id="bt"></i> BT</div>
              <div class="col-3">
                <i class="flag-icon flag-icon-bv" title="bv" id="bv"></i> BV</div>
              <div class="col-3">
                <i class="flag-icon flag-icon-bw" title="bw" id="bw"></i> BW</div>
              <div class="col-3">
                <i class="flag-icon flag-icon-by" title="by" id="by"></i> BY</div>
              <div class="col-3">
                <i class="flag-icon flag-icon-bz" title="bz" id="bz"></i> BZ</div>
              <div class="col-3">
                <i class="flag-icon flag-icon-ca" title="ca" id="ca"></i> CA</div>
              <div class="col-3">
                <i class="flag-icon flag-icon-cc" title="cc" id="cc"></i> CC</div>
              <div class="col-3">
                <i class="flag-icon flag-icon-cd" title="cd" id="cd"></i> CD</div>
              <div class="col-3">
                <i class="flag-icon flag-icon-cf" title="cf" id="cf"></i> CF</div>
              <div class="col-3">
                <i class="flag-icon flag-icon-cg" title="cg" id="cg"></i> CG</div>
              <div class="col-3">
                <i class="flag-icon flag-icon-ch" title="ch" id="ch"></i> CH</div>
              <div class="col-3">
                <i class="flag-icon flag-icon-ci" title="ci" id="ci"></i> CI</div>
              <div class="col-3">
                <i class="flag-icon flag-icon-ck" title="ck" id="ck"></i> CK</div>
              <div class="col-3">
                <i class="flag-icon flag-icon-cl" title="cl" id="cl"></i> CL</div>
              <div class="col-3">
                <i class="flag-icon flag-icon-cm" title="cm" id="cm"></i> CM</div>
              <div class="col-3">
                <i class="flag-icon flag-icon-cn" title="cn" id="cn"></i> CN</div>
              <div class="col-3">
                <i class="flag-icon flag-icon-co" title="co" id="co"></i> CO</div>
              <div class="col-3">
                <i class="flag-icon flag-icon-cr" title="cr" id="cr"></i> CR</div>
              <div class="col-3">
                <i class="flag-icon flag-icon-cu" title="cu" id="cu"></i> CU</div>
              <div class="col-3">
                <i class="flag-icon flag-icon-cv" title="cv" id="cv"></i> CV</div>
              <div class="col-3">
                <i class="flag-icon flag-icon-cw" title="cw" id="cw"></i> CW</div>
              <div class="col-3">
                <i class="flag-icon flag-icon-cx" title="cx" id="cx"></i> CX</div>
              <div class="col-3">
                <i class="flag-icon flag-icon-cy" title="cy" id="cy"></i> CY</div>
              <div class="col-3">
                <i class="flag-icon flag-icon-cz" title="cz" id="cz"></i> CZ</div>
              <div class="col-3">
                <i class="flag-icon flag-icon-de" title="de" id="de"></i> DE</div>
              <div class="col-3">
                <i class="flag-icon flag-icon-dj" title="dj" id="dj"></i> DJ</div>
              <div class="col-3">
                <i class="flag-icon flag-icon-dk" title="dk" id="dk"></i> DK</div>
              <div class="col-3">
                <i class="flag-icon flag-icon-dm" title="dm" id="dm"></i> DM</div>
              <div class="col-3">
                <i class="flag-icon flag-icon-do" title="do" id="do"></i> DO</div>
              <div class="col-3">
                <i class="flag-icon flag-icon-dz" title="dz" id="dz"></i> DZ</div>
              <div class="col-3">
                <i class="flag-icon flag-icon-ec" title="ec" id="ec"></i> EC</div>
              <div class="col-3">
                <i class="flag-icon flag-icon-ee" title="ee" id="ee"></i> EE</div>
              <div class="col-3">
                <i class="flag-icon flag-icon-eg" title="eg" id="eg"></i> EG</div>
              <div class="col-3">
                <i class="flag-icon flag-icon-eh" title="eh" id="eh"></i> EH</div>
              <div class="col-3">
                <i class="flag-icon flag-icon-er" title="er" id="er"></i> ER</div>
              <div class="col-3">
                <i class="flag-icon flag-icon-es" title="es" id="es"></i> ES</div>
              <div class="col-3">
                <i class="flag-icon flag-icon-et" title="et" id="et"></i> ET</div>
              <div class="col-3">
                <i class="flag-icon flag-icon-fi" title="fi" id="fi"></i> FI</div>
              <div class="col-3">
                <i class="flag-icon flag-icon-fj" title="fj" id="fj"></i> FJ</div>
              <div class="col-3">
                <i class="flag-icon flag-icon-fk" title="fk" id="fk"></i> FK</div>
              <div class="col-3">
                <i class="flag-icon flag-icon-fm" title="fm" id="fm"></i> FM</div>
              <div class="col-3">
                <i class="flag-icon flag-icon-fo" title="fo" id="fo"></i> FO</div>
              <div class="col-3">
                <i class="flag-icon flag-icon-fr" title="fr" id="fr"></i> FR</div>
              <div class="col-3">
                <i class="flag-icon flag-icon-ga" title="ga" id="ga"></i> GA</div>
              <div class="col-3">
                <i class="flag-icon flag-icon-gb" title="gb" id="gb"></i> GB</div>
              <div class="col-3">
                <i class="flag-icon flag-icon-gd" title="gd" id="gd"></i> GD</div>
              <div class="col-3">
                <i class="flag-icon flag-icon-ge" title="ge" id="ge"></i> GE</div>
              <div class="col-3">
                <i class="flag-icon flag-icon-gf" title="gf" id="gf"></i> GF</div>
              <div class="col-3">
                <i class="flag-icon flag-icon-gg" title="gg" id="gg"></i> GG</div>
              <div class="col-3">
                <i class="flag-icon flag-icon-gh" title="gh" id="gh"></i> GH</div>
              <div class="col-3">
                <i class="flag-icon flag-icon-gi" title="gi" id="gi"></i> GI</div>
              <div class="col-3">
                <i class="flag-icon flag-icon-gl" title="gl" id="gl"></i> GL</div>
              <div class="col-3">
                <i class="flag-icon flag-icon-gm" title="gm" id="gm"></i> GM</div>
              <div class="col-3">
                <i class="flag-icon flag-icon-gn" title="gn" id="gn"></i> GN</div>
              <div class="col-3">
                <i class="flag-icon flag-icon-gp" title="gp" id="gp"></i> GP</div>
              <div class="col-3">
                <i class="flag-icon flag-icon-gq" title="gq" id="gq"></i> GQ</div>
              <div class="col-3">
                <i class="flag-icon flag-icon-gr" title="gr" id="gr"></i> GR</div>
              <div class="col-3">
                <i class="flag-icon flag-icon-gs" title="gs" id="gs"></i> GS</div>
              <div class="col-3">
                <i class="flag-icon flag-icon-gt" title="gt" id="gt"></i> GT</div>
              <div class="col-3">
                <i class="flag-icon flag-icon-gu" title="gu" id="gu"></i> GU</div>
              <div class="col-3">
                <i class="flag-icon flag-icon-gw" title="gw" id="gw"></i> GW</div>
              <div class="col-3">
                <i class="flag-icon flag-icon-gy" title="gy" id="gy"></i> GY</div>
              <div class="col-3">
                <i class="flag-icon flag-icon-hk" title="hk" id="hk"></i> HK</div>
              <div class="col-3">
                <i class="flag-icon flag-icon-hm" title="hm" id="hm"></i> HM</div>
              <div class="col-3">
                <i class="flag-icon flag-icon-hn" title="hn" id="hn"></i> HN</div>
              <div class="col-3">
                <i class="flag-icon flag-icon-hr" title="hr" id="hr"></i> HR</div>
              <div class="col-3">
                <i class="flag-icon flag-icon-ht" title="ht" id="ht"></i> HT</div>
              <div class="col-3">
                <i class="flag-icon flag-icon-hu" title="hu" id="hu"></i> HU</div>
              <div class="col-3">
                <i class="flag-icon flag-icon-id" title="id" id="id"></i> ID</div>
              <div class="col-3">
                <i class="flag-icon flag-icon-ie" title="ie" id="ie"></i> IE</div>
              <div class="col-3">
                <i class="flag-icon flag-icon-il" title="il" id="il"></i> IL</div>
              <div class="col-3">
                <i class="flag-icon flag-icon-im" title="im" id="im"></i> IM</div>
              <div class="col-3">
                <i class="flag-icon flag-icon-in" title="in" id="in"></i> IN</div>
              <div class="col-3">
                <i class="flag-icon flag-icon-io" title="io" id="io"></i> IO</div>
              <div class="col-3">
                <i class="flag-icon flag-icon-iq" title="iq" id="iq"></i> IQ</div>
              <div class="col-3">
                <i class="flag-icon flag-icon-ir" title="ir" id="ir"></i> IR</div>
              <div class="col-3">
                <i class="flag-icon flag-icon-is" title="is" id="is"></i> IS</div>
              <div class="col-3">
                <i class="flag-icon flag-icon-it" title="it" id="it"></i> IT</div>
              <div class="col-3">
                <i class="flag-icon flag-icon-je" title="je" id="je"></i> JE</div>
              <div class="col-3">
                <i class="flag-icon flag-icon-jm" title="jm" id="jm"></i> JM</div>
              <div class="col-3">
                <i class="flag-icon flag-icon-jo" title="jo" id="jo"></i> JO</div>
              <div class="col-3">
                <i class="flag-icon flag-icon-jp" title="jp" id="jp"></i> JP</div>
              <div class="col-3">
                <i class="flag-icon flag-icon-ke" title="ke" id="ke"></i> KE</div>
              <div class="col-3">
                <i class="flag-icon flag-icon-kg" title="kg" id="kg"></i> KG</div>
              <div class="col-3">
                <i class="flag-icon flag-icon-kh" title="kh" id="kh"></i> KH</div>
              <div class="col-3">
                <i class="flag-icon flag-icon-ki" title="ki" id="ki"></i> KI</div>
              <div class="col-3">
                <i class="flag-icon flag-icon-km" title="km" id="km"></i> KM</div>
              <div class="col-3">
                <i class="flag-icon flag-icon-kn" title="kn" id="kn"></i> KN</div>
              <div class="col-3">
                <i class="flag-icon flag-icon-kp" title="kp" id="kp"></i> KP</div>
              <div class="col-3">
                <i class="flag-icon flag-icon-kr" title="kr" id="kr"></i> KR</div>
              <div class="col-3">
                <i class="flag-icon flag-icon-kw" title="kw" id="kw"></i> KW</div>
              <div class="col-3">
                <i class="flag-icon flag-icon-ky" title="ky" id="ky"></i> KY</div>
              <div class="col-3">
                <i class="flag-icon flag-icon-kz" title="kz" id="kz"></i> KZ</div>
              <div class="col-3">
                <i class="flag-icon flag-icon-la" title="la" id="la"></i> LA</div>
              <div class="col-3">
                <i class="flag-icon flag-icon-lb" title="lb" id="lb"></i> LB</div>
              <div class="col-3">
                <i class="flag-icon flag-icon-lc" title="lc" id="lc"></i> LC</div>
              <div class="col-3">
                <i class="flag-icon flag-icon-li" title="li" id="li"></i> LI</div>
              <div class="col-3">
                <i class="flag-icon flag-icon-lk" title="lk" id="lk"></i> LK</div>
              <div class="col-3">
                <i class="flag-icon flag-icon-lr" title="lr" id="lr"></i> LR</div>
              <div class="col-3">
                <i class="flag-icon flag-icon-ls" title="ls" id="ls"></i> LS</div>
              <div class="col-3">
                <i class="flag-icon flag-icon-lt" title="lt" id="lt"></i> LT</div>
              <div class="col-3">
                <i class="flag-icon flag-icon-lu" title="lu" id="lu"></i> LU</div>
              <div class="col-3">
                <i class="flag-icon flag-icon-lv" title="lv" id="lv"></i> LV</div>
              <div class="col-3">
                <i class="flag-icon flag-icon-ly" title="ly" id="ly"></i> LY</div>
              <div class="col-3">
                <i class="flag-icon flag-icon-ma" title="ma" id="ma"></i> MA</div>
              <div class="col-3">
                <i class="flag-icon flag-icon-mc" title="mc" id="mc"></i> MC</div>
              <div class="col-3">
                <i class="flag-icon flag-icon-md" title="md" id="md"></i> MD</div>
              <div class="col-3">
                <i class="flag-icon flag-icon-me" title="me" id="me"></i> ME</div>
              <div class="col-3">
                <i class="flag-icon flag-icon-mf" title="mf" id="mf"></i> MF</div>
              <div class="col-3">
                <i class="flag-icon flag-icon-mg" title="mg" id="mg"></i> MG</div>
              <div class="col-3">
                <i class="flag-icon flag-icon-mh" title="mh" id="mh"></i> MH</div>
              <div class="col-3">
                <i class="flag-icon flag-icon-mk" title="mk" id="mk"></i> MK</div>
              <div class="col-3">
                <i class="flag-icon flag-icon-ml" title="ml" id="ml"></i> ML</div>
              <div class="col-3">
                <i class="flag-icon flag-icon-mm" title="mm" id="mm"></i> MM</div>
              <div class="col-3">
                <i class="flag-icon flag-icon-mn" title="mn" id="mn"></i> MN</div>
              <div class="col-3">
                <i class="flag-icon flag-icon-mo" title="mo" id="mo"></i> MO</div>
              <div class="col-3">
                <i class="flag-icon flag-icon-mp" title="mp" id="mp"></i> MP</div>
              <div class="col-3">
                <i class="flag-icon flag-icon-mq" title="mq" id="mq"></i> MQ</div>
              <div class="col-3">
                <i class="flag-icon flag-icon-mr" title="mr" id="mr"></i> MR</div>
              <div class="col-3">
                <i class="flag-icon flag-icon-ms" title="ms" id="ms"></i> MS</div>
              <div class="col-3">
                <i class="flag-icon flag-icon-mt" title="mt" id="mt"></i> MT</div>
              <div class="col-3">
                <i class="flag-icon flag-icon-mu" title="mu" id="mu"></i> MU</div>
              <div class="col-3">
                <i class="flag-icon flag-icon-mv" title="mv" id="mv"></i> MV</div>
              <div class="col-3">
                <i class="flag-icon flag-icon-mw" title="mw" id="mw"></i> MW</div>
              <div class="col-3">
                <i class="flag-icon flag-icon-mx" title="mx" id="mx"></i> MX</div>
              <div class="col-3">
                <i class="flag-icon flag-icon-my" title="my" id="my"></i> MY</div>
              <div class="col-3">
                <i class="flag-icon flag-icon-mz" title="mz" id="mz"></i> MZ</div>
              <div class="col-3">
                <i class="flag-icon flag-icon-na" title="na" id="na"></i> NA</div>
              <div class="col-3">
                <i class="flag-icon flag-icon-nc" title="nc" id="nc"></i> NC</div>
              <div class="col-3">
                <i class="flag-icon flag-icon-ne" title="ne" id="ne"></i> NE</div>
              <div class="col-3">
                <i class="flag-icon flag-icon-nf" title="nf" id="nf"></i> NF</div>
              <div class="col-3">
                <i class="flag-icon flag-icon-ng" title="ng" id="ng"></i> NG</div>
              <div class="col-3">
                <i class="flag-icon flag-icon-ni" title="ni" id="ni"></i> NI</div>
              <div class="col-3">
                <i class="flag-icon flag-icon-nl" title="nl" id="nl"></i> NL</div>
              <div class="col-3">
                <i class="flag-icon flag-icon-no" title="no" id="no"></i> NO</div>
              <div class="col-3">
                <i class="flag-icon flag-icon-np" title="np" id="np"></i> NP</div>
              <div class="col-3">
                <i class="flag-icon flag-icon-nr" title="nr" id="nr"></i> NR</div>
              <div class="col-3">
                <i class="flag-icon flag-icon-nu" title="nu" id="nu"></i> NU</div>
              <div class="col-3">
                <i class="flag-icon flag-icon-nz" title="nz" id="nz"></i> NZ</div>
              <div class="col-3">
                <i class="flag-icon flag-icon-om" title="om" id="om"></i> OM</div>
              <div class="col-3">
                <i class="flag-icon flag-icon-pa" title="pa" id="pa"></i> PA</div>
              <div class="col-3">
                <i class="flag-icon flag-icon-pe" title="pe" id="pe"></i> PE</div>
              <div class="col-3">
                <i class="flag-icon flag-icon-pf" title="pf" id="pf"></i> PF</div>
              <div class="col-3">
                <i class="flag-icon flag-icon-pg" title="pg" id="pg"></i> PG</div>
              <div class="col-3">
                <i class="flag-icon flag-icon-ph" title="ph" id="ph"></i> PH</div>
              <div class="col-3">
                <i class="flag-icon flag-icon-pk" title="pk" id="pk"></i> PK</div>
              <div class="col-3">
                <i class="flag-icon flag-icon-pl" title="pl" id="pl"></i> PL</div>
              <div class="col-3">
                <i class="flag-icon flag-icon-pm" title="pm" id="pm"></i> PM</div>
              <div class="col-3">
                <i class="flag-icon flag-icon-pn" title="pn" id="pn"></i> PN</div>
              <div class="col-3">
                <i class="flag-icon flag-icon-pr" title="pr" id="pr"></i> PR</div>
              <div class="col-3">
                <i class="flag-icon flag-icon-ps" title="ps" id="ps"></i> PS</div>
              <div class="col-3">
                <i class="flag-icon flag-icon-pt" title="pt" id="pt"></i> PT</div>
              <div class="col-3">
                <i class="flag-icon flag-icon-pw" title="pw" id="pw"></i> PW</div>
              <div class="col-3">
                <i class="flag-icon flag-icon-py" title="py" id="py"></i> PY</div>
              <div class="col-3">
                <i class="flag-icon flag-icon-qa" title="qa" id="qa"></i> QA</div>
              <div class="col-3">
                <i class="flag-icon flag-icon-re" title="re" id="re"></i> RE</div>
              <div class="col-3">
                <i class="flag-icon flag-icon-ro" title="ro" id="ro"></i> RO</div>
              <div class="col-3">
                <i class="flag-icon flag-icon-rs" title="rs" id="rs"></i> RS</div>
              <div class="col-3">
                <i class="flag-icon flag-icon-ru" title="ru" id="ru"></i> RU</div>
              <div class="col-3">
                <i class="flag-icon flag-icon-rw" title="rw" id="rw"></i> RW</div>
              <div class="col-3">
                <i class="flag-icon flag-icon-sa" title="sa" id="sa"></i> SA</div>
              <div class="col-3">
                <i class="flag-icon flag-icon-sb" title="sb" id="sb"></i> SB</div>
              <div class="col-3">
                <i class="flag-icon flag-icon-sc" title="sc" id="sc"></i> SC</div>
              <div class="col-3">
                <i class="flag-icon flag-icon-sd" title="sd" id="sd"></i> SD</div>
              <div class="col-3">
                <i class="flag-icon flag-icon-se" title="se" id="se"></i> SE</div>
              <div class="col-3">
                <i class="flag-icon flag-icon-sg" title="sg" id="sg"></i> SG</div>
              <div class="col-3">
                <i class="flag-icon flag-icon-sh" title="sh" id="sh"></i> SH</div>
              <div class="col-3">
                <i class="flag-icon flag-icon-si" title="si" id="si"></i> SI</div>
              <div class="col-3">
                <i class="flag-icon flag-icon-sj" title="sj" id="sj"></i> SJ</div>
              <div class="col-3">
                <i class="flag-icon flag-icon-sk" title="sk" id="sk"></i> SK</div>
              <div class="col-3">
                <i class="flag-icon flag-icon-sl" title="sl" id="sl"></i> SL</div>
              <div class="col-3">
                <i class="flag-icon flag-icon-sm" title="sm" id="sm"></i> SM</div>
              <div class="col-3">
                <i class="flag-icon flag-icon-sn" title="sn" id="sn"></i> SN</div>
              <div class="col-3">
                <i class="flag-icon flag-icon-so" title="so" id="so"></i> SO</div>
              <div class="col-3">
                <i class="flag-icon flag-icon-sr" title="sr" id="sr"></i> SR</div>
              <div class="col-3">
                <i class="flag-icon flag-icon-ss" title="ss" id="ss"></i> SS</div>
              <div class="col-3">
                <i class="flag-icon flag-icon-st" title="st" id="st"></i> ST</div>
              <div class="col-3">
                <i class="flag-icon flag-icon-sv" title="sv" id="sv"></i> SV</div>
              <div class="col-3">
                <i class="flag-icon flag-icon-sx" title="sx" id="sx"></i> SX</div>
              <div class="col-3">
                <i class="flag-icon flag-icon-sy" title="sy" id="sy"></i> SY</div>
              <div class="col-3">
                <i class="flag-icon flag-icon-sz" title="sz" id="sz"></i> SZ</div>
              <div class="col-3">
                <i class="flag-icon flag-icon-tc" title="tc" id="tc"></i> TC</div>
              <div class="col-3">
                <i class="flag-icon flag-icon-td" title="td" id="td"></i> TD</div>
              <div class="col-3">
                <i class="flag-icon flag-icon-tf" title="tf" id="tf"></i> TF</div>
              <div class="col-3">
                <i class="flag-icon flag-icon-tg" title="tg" id="tg"></i> TG</div>
              <div class="col-3">
                <i class="flag-icon flag-icon-th" title="th" id="th"></i> TH</div>
              <div class="col-3">
                <i class="flag-icon flag-icon-tj" title="tj" id="tj"></i> TJ</div>
              <div class="col-3">
                <i class="flag-icon flag-icon-tk" title="tk" id="tk"></i> TK</div>
              <div class="col-3">
                <i class="flag-icon flag-icon-tl" title="tl" id="tl"></i> TL</div>
              <div class="col-3">
                <i class="flag-icon flag-icon-tm" title="tm" id="tm"></i> TM</div>
              <div class="col-3">
                <i class="flag-icon flag-icon-tn" title="tn" id="tn"></i> TN</div>
              <div class="col-3">
                <i class="flag-icon flag-icon-to" title="to" id="to"></i> TO</div>
              <div class="col-3">
                <i class="flag-icon flag-icon-tr" title="tr" id="tr"></i> TR</div>
              <div class="col-3">
                <i class="flag-icon flag-icon-tt" title="tt" id="tt"></i> TT</div>
              <div class="col-3">
                <i class="flag-icon flag-icon-tv" title="tv" id="tv"></i> TV</div>
              <div class="col-3">
                <i class="flag-icon flag-icon-tw" title="tw" id="tw"></i> TW</div>
              <div class="col-3">
                <i class="flag-icon flag-icon-tz" title="tz" id="tz"></i> TZ</div>
              <div class="col-3">
                <i class="flag-icon flag-icon-ua" title="ua" id="ua"></i> UA</div>
              <div class="col-3">
                <i class="flag-icon flag-icon-ug" title="ug" id="ug"></i> UG</div>
              <div class="col-3">
                <i class="flag-icon flag-icon-um" title="um" id="um"></i> UM</div>
              <div class="col-3">
                <i class="flag-icon flag-icon-us" title="us" id="us"></i> US</div>
              <div class="col-3">
                <i class="flag-icon flag-icon-uy" title="uy" id="uy"></i> UY</div>
              <div class="col-3">
                <i class="flag-icon flag-icon-uz" title="uz" id="uz"></i> UZ</div>
              <div class="col-3">
                <i class="flag-icon flag-icon-va" title="va" id="va"></i> VA</div>
              <div class="col-3">
                <i class="flag-icon flag-icon-vc" title="vc" id="vc"></i> VC</div>
              <div class="col-3">
                <i class="flag-icon flag-icon-ve" title="ve" id="ve"></i> VE</div>
              <div class="col-3">
                <i class="flag-icon flag-icon-vg" title="vg" id="vg"></i> VG</div>
              <div class="col-3">
                <i class="flag-icon flag-icon-vi" title="vi" id="vi"></i> VI</div>
              <div class="col-3">
                <i class="flag-icon flag-icon-vn" title="vn" id="vn"></i> VN</div>
              <div class="col-3">
                <i class="flag-icon flag-icon-vu" title="vu" id="vu"></i> VU</div>
              <div class="col-3">
                <i class="flag-icon flag-icon-wf" title="wf" id="wf"></i> WF</div>
              <div class="col-3">
                <i class="flag-icon flag-icon-ws" title="ws" id="ws"></i> WS</div>
              <div class="col-3">
                <i class="flag-icon flag-icon-ye" title="ye" id="ye"></i> YE</div>
              <div class="col-3">
                <i class="flag-icon flag-icon-yt" title="yt" id="yt"></i> YT</div>
              <div class="col-3">
                <i class="flag-icon flag-icon-za" title="za" id="za"></i> ZA</div>
              <div class="col-3">
                <i class="flag-icon flag-icon-zm" title="zm" id="zm"></i> ZM</div>
              <div class="col-3">
                <i class="flag-icon flag-icon-zw" title="zw" id="zw"></i> ZW</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'flagIcons'
}
</script>